import { ChainMonitor } from "@/features/oversight/monitoring";

export default function MonitoringChainPage() {
  return <ChainMonitor />;
}
